var map = {
	"./1.jpg": 1394,
	"./2.jpg": 2557,
	"./3.jpg": 306,
	"./4.jpg": 5273,
	"./5.jpg": 9468,
	"./6.jpg": 1862,
	"./7.jpg": 8267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1831;